import React, { useState } from "react";
import "./pos.css";

export const PosInvoice = React.forwardRef((props, ref) => {
  const {
    fixData,
    totalAmount,
    netTotal,
    discount,
    VAT,
    due,
    invoice_no,
    pay,
    change,
    cuttingCharge,
    dressingCharge,
    vatAmount,
    discountAmount,
    saleBy,
    payment,
  } = props;

  const [currentDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const [currentTime] = useState(new Date());
  const time = currentTime.toLocaleTimeString();

  const paymentTypes = {
    1: "Cash",
    2: "Card",
    3: "bKash",
    4: "Nagad",
  };

  return (
    <div ref={ref} className="pos-invoice">
      <div className="invoice-header">
        <div className="shop-name">MANAVIEA ATTIRE</div>
        <div className="shop-tagline">" UNVEIL YOUR ELEGANCE "</div>
        <div className="shop-address">
          Level-3, Block-C, Shop-32
          <br />
          Bashundhara City Shopping Mall, Dhaka.
          <br />
          Mobile: +8801319-931119,+8801320-656271
          <br />
          <span className="vat-details">
            <span>
              VAT Reg No: 004125221-0203 &nbsp; Mushak: 6.3
            </span>

          </span>
        </div>
      </div>

      <div className="invoice-title">BILLING INVOICE</div>

      <div className="invoice-meta">
        <div className="meta-row">
          <span>Date:</span>
          <span>{currentDate}</span>
        </div>
        <div className="meta-row">
          <span>Time:</span>
          <span>{time}</span>
        </div>
        <div className="meta-row">
          <span>Sold By:</span>
          <span>{saleBy}</span>
        </div>
        <div className="meta-row">
          <span>Invoice No:</span>
          <span>{invoice_no}</span>
        </div>
      </div>

      <div className="items-table">
        <div className="table-header">
          <div className="col-serial">#</div>
          <div className="col-desc">Product & MV=CODE</div>
          <div className="col-qty">Qty</div>
          <div className="col-price">Price</div>
          <div className="col-total">Amount</div>
        </div>

        <div className="table-body">
          {fixData &&
            fixData.map((item, index) => (
              <div className="table-row" key={index}>
                <div className="col-serial">{index + 1}</div>
                <div className="col-desc">
                  {item.product_name} {item.itemCode}
                </div>
                <div className="col-qty">
                  {item.quantity} {item.unit}
                </div>
                <div className="col-price">{item.sale_price}</div>
                <div className="col-total">{item.itemTotal}.00</div>
              </div>
            ))}
        </div>

        <div className="table-footer">
          <div className="summary-row total-row">
            <div className="summary-label">Sub Total : </div>
            <div className="summary-value">{totalAmount}</div>
          </div>
          {discount > 0 && (
            <div className="summary-row">
              <div className="summary-label">Discount ({discount}%)</div>
              <div className="summary-value">{discountAmount}.00</div>
            </div>
          )}
          {VAT > 0 && (
            <div className="summary-row">
              <div className="summary-label">VAT ({VAT}%)</div>
              <div className="summary-value">{vatAmount}</div>
            </div>
          )}
          {cuttingCharge && (
            <div className="summary-row">
              <div className="summary-label">Cutting Charge</div>
              <div className="summary-value">{cuttingCharge}.00</div>
            </div>
          )}
          {dressingCharge && (
            <div className="summary-row">
              <div className="summary-label">Dressing Charge</div>
              <div className="summary-value">{dressingCharge}.00</div>
            </div>
          )}
          <div className="summary-row total-row">
            <div className="summary-label">Net Payable : </div>
            <div className="summary-value">{netTotal}</div>
          </div>
          <div className="summary-row total-row">
            <div className="summary-label">Payment Mode : </div>
            <div className="summary-value">{paymentTypes[payment]}</div>
          </div>
          {pay > 0 && (
            <div className="summary-row">
              <div className="summary-label">Total Paid : </div>
              <div className="summary-value">{pay}.00</div>
            </div>
          )}
          {due > 0 && (
            <div className="summary-row">
              <div className="summary-label">Total Due : </div>
              <div className="summary-value">{due}</div>
            </div>
          )}
          {change > 0 && (
            <div className="summary-row">
              <div className="summary-label">Change Amount : </div>
              <div className="summary-value">{Math.round(change)}</div>
            </div>
          )}
        </div>
      </div>

      <div className="invoice-footer">
        <div className="thank-you">"It's Our Pleasure To Serve You!!"</div>
        <div className="terms">
{/* 
        <div
  style={{
    textAlign: "left",
    fontSize: "14px",
    lineHeight: "1.6",
    color: "#333",
    margin: "10px 0"
  }}
>
  Exchange is not applicable without this receipt. Items may only be exchanged,
  subjected to Manaviea's sale policies within 15 days. No cash refund is
  applicable. Discounted products are non-refundable and non-exchangeable
</div> */}
        <div
  style={{
    textAlign: "center",
    fontSize: "14px",
    lineHeight: "1.6",
    color: "#333",
    margin: "10px 0"
  }}
>
  Exchange is not applicable without this receipt. Items may only be exchanged,
  subjected to Manaviea's sale policies within 15 days. No cash refund is
  applicable.Discounted items are not eligible for refund or exchange.
</div>




          <div className="thank-you">Website : www.manavieaattire.com</div>
          <div>Powered by MerinaSoft</div>
          <div>+8801704473813</div>
          <div>173, Arambagh, Motijheel</div>
        </div>
      </div>
    </div>
  );
});
